export default __webpack_public_path__ + "static/media/link.ef105414.svg";